export default __webpack_public_path__ + "static/media/charted.ace60386.jpg";